import * as React from "react";
import { FC } from "react";

import AuthContext from "src/context/AuthContext";
import DatasetContext from "src/context/DatasetContext";
import { AdminPermissions } from "./Permissions";

interface IProps {
	children?: any;
	permissions: string[];
	type: string;
}

const DatasetAuthorizationWrapper: FC<IProps> = (props) => {
	const dataset = React.useContext(DatasetContext);
	return (
		<AuthContext.Consumer>
			{({ currentUser }) => {
				if (!currentUser) {
					console.error("User is not logged in");
					return null;
				}
				if (props.type === "hide") {
					return currentUser.permissions!.includes(
						AdminPermissions.GlobalAdmin
					) ||
						(currentUser.datasetPermissions &&
							currentUser.datasetPermissions.some(
								(dp) =>
									dp.datasetId == dataset.currentDataset.id &&
									dp.permissions!.some((p) => props.permissions.includes(p))
							))
						? React.cloneElement(props.children)
						: null;
				} else if (props.type === "disable") {
					return currentUser.permissions!.includes(
						AdminPermissions.GlobalAdmin
					) ||
						(currentUser.datasetPermissions &&
							currentUser.datasetPermissions.some(
								(dp) =>
									dp.datasetId == dataset.currentDataset.id &&
									dp.permissions!.some((p) => props.permissions.includes(p))
							))
						? React.cloneElement(props.children)
						: React.cloneElement(props.children, { disabled: true });
				} else {
					return null;
				}
			}}
		</AuthContext.Consumer>
	);
};

export default DatasetAuthorizationWrapper;
